// deno-fmt-ignore-file
import { IntegerKey } from '../../types/record.mjs';
import { CreateRecord } from './record_create.mjs';
export function FromIntegerKey(_key, value) {
    const result = CreateRecord(IntegerKey, value);
    return result;
}
